




























































































































































































































































import { Component, Prop, Watch, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { domService } from '../dom-service';
import { SwIcon } from '../sw-icon';
import SwTab from './sw-tab.vue';
import { TabProps, ProvidedTabParam } from './types';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-tab-nav';

@Component({
  components: {
    SwIcon,
    SwTab,
  },
})
export default class SwTabNav extends SwExtendedVue {
  @Prop({ type: Array, required: true })
  tabs: TabProps[];

  @Prop({ type: String, required: true })
  activeTabId: string;

  @Inject()
  tabParam: ProvidedTabParam;

  cssPrefix: string = cssPrefix;

  showMover: boolean = false;
  tabsContLeft: number = 0;
  activeL2IndicatorStyle: CSSStyleOptions = {};
  hoverL2IndicatorStyle: CSSStyleOptions = {};
  arrowIndicatorStyle: CSSStyleOptions = {};

  get contStyle(): CSSStyleOptions {
    if (this.tabParam.vertical && !this.showMover) {
      return {
        margin: '20px 0',
      };
    }
    return {};
  }

  private updateIndicatorStyle(): void {
    if (!this.$refs.activeL2Indicator && !this.$refs.arrowIndicator) { return; }

    const activeSwTab = (this.$refs.allTabs as SwTab[]).find(tab => (tab.active));
    if (activeSwTab && activeSwTab.$el) {
      const tabRect = activeSwTab.$el.getBoundingClientRect();
      if (this.$refs.activeL2Indicator) {
        const offsetParent = (this.$refs.activeL2Indicator as HTMLElement).offsetParent;
        if (offsetParent) {
          const parentRect = offsetParent.getBoundingClientRect();
          this.activeL2IndicatorStyle = {
            width: `${tabRect.width}px`,
            left: `${tabRect.left - parentRect.left}px`,
          };
        }
      }
      if (this.$refs.arrowIndicator) {
        const offsetParent = (this.$refs.arrowIndicator as HTMLElement).offsetParent;
        if (offsetParent) {
          const parentRect = offsetParent.getBoundingClientRect();
          const indicatorWidth = (this.$refs.arrowIndicator as HTMLElement).offsetWidth;
          this.arrowIndicatorStyle = {
            left: `${tabRect.left - parentRect.left + (tabRect.width - indicatorWidth) / 2}px`,
          };
        }
      }
    } else {
      this.activeL2IndicatorStyle = {};
      this.arrowIndicatorStyle = {};
    }
  }

  @Watch('activeTabId')
  @Watch('tabsContLeft')
  private delayUpdateIndicatorStyle() {
    this.$nextTick(() => {
      this.updateIndicatorStyle();
    });
  }

  @Watch('showMover')
  private watchShowMover(val: boolean) {
    if (!val) {
      this.tabsContLeft = 0;
    }
  }

  private normalizeTabProps(tabProps: TabProps): TabProps {
    const {
      tabId, label, icon, disabled, closable, innerRender,
    } = tabProps;
    return {
      tabId, label, icon, disabled, closable, innerRender,
    };
  }

  private tabStyle(index: number): CSSStyleOptions {
    if (this.tabParam.tabGutter === undefined) { return {}; }
    return {
      marginLeft: index === 0 ? undefined : `${this.tabParam.tabGutter}px`,
    };
  }

  private shouldShowMover(): boolean {
    return ((this.$el as HTMLElement).offsetWidth < (this.$refs.tabsCont as HTMLElement).offsetWidth);
  }

  private handleTabsContResize() {
    this.showMover = this.shouldShowMover();
    this.updateIndicatorStyle();
  }

  private onClickMover(dir: string) {
    const dist = 120 * (dir === 'backward' ? -1 : 1);
    const smallest = (this.$refs.cont as HTMLElement).offsetWidth - (this.$refs.tabsCont as HTMLElement).offsetWidth;
    this.tabsContLeft -= dist;
    if (this.tabsContLeft > 0) {
      this.tabsContLeft = 0;
    } else if (this.tabsContLeft < smallest) {
      this.tabsContLeft = smallest;
    }
  }

  private onMouseEnterTab(event: MouseEvent, tab: TabProps) {
    if (this.tabParam.level <= 1) { return; }
    if (tab.disabled) { return; }
    if (!this.$refs.hoverL2Indicator) { return; }
    const offsetParent = (this.$refs.hoverL2Indicator as HTMLElement).offsetParent;
    if (!offsetParent) { return; }

    const tabRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const parentRect = offsetParent.getBoundingClientRect();
    this.hoverL2IndicatorStyle = {
      width: `${tabRect.width}px`,
      left: `${tabRect.left - parentRect.left}px`,
    };
  }

  private onMouseLeaveTab() {
    if (this.tabParam.level <= 1) { return; }
    this.hoverL2IndicatorStyle = {
      width: '0px',
    };
  }

  mounted() {
    this.$nextTick(() => {
      this.showMover = this.shouldShowMover();
      this.updateIndicatorStyle();
      domService.resizeObserver.on(this.$refs.tabsContSizeSensor as HTMLElement, this.handleTabsContResize);
      domService.resizeObserver.on(this.$refs.contSizeSensor as HTMLElement, this.handleTabsContResize);
    });
  }

  beforeDestroy() {
    domService.resizeObserver.off(this.$refs.tabsContSizeSensor as HTMLElement, this.handleTabsContResize);
    domService.resizeObserver.off(this.$refs.contSizeSensor as HTMLElement, this.handleTabsContResize);
  }
}
